import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage, setPopupMessage } from "./message";


import AuthService from "../services/auth.service";
import { ContactlessOutlined } from "@mui/icons-material";

const user = JSON.parse(localStorage.getItem("user"));

const list = {
  list: [],
  pageSize: 25,
  page: 0,
  total: 0,
  nextPage: 0
};


const user_sessions = {data: list, loading: false};
const user_roles = {data: list, loading: false};


export const register = createAsyncThunk(
  "auth/register",
  async ({ user }, thunkAPI) => {
    try {
      const data = await AuthService.register(user);
      thunkAPI.dispatch(setMessage(data.data.message));
      return { user: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateUserPassword = createAsyncThunk(
  "auth/updateUserPassword",

  async ({ user }, thunkAPI) => {
    try {
      const data = await AuthService.updateUserPassword(user);
      return { user: data };

    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",

  async ({ username, password }, thunkAPI) => {
    try {

      const data = await AuthService.login(username, password);
      //go get the ACL for the user 
      let search = {
        username: username,
      }
      //thunkAPI.dispatch(getCurrentUsersRoles({search}));

      return { user: data };

    } catch (error) {


      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getSessions = createAsyncThunk(
  "auth/get_sessions",
  async ( {page,pageSize},thunkAPI) => {
    try {
      const data = await AuthService.getSessions(page,pageSize);
      return { sessions: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const updateSession = createAsyncThunk(
  "auth/updateSession",
  async ( {id,isBlocked},thunkAPI) => {
    try {
      const data = await AuthService.updateSession(id,isBlocked);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);


export const getUserRoles = createAsyncThunk(
  "auth/get_user_roles",
  async ({search}, thunkAPI) => {
    try {
      
      const data = await AuthService.getUserRoles(search);
      return { data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);



export const logout = createAsyncThunk("auth/logout", async () => {
  await AuthService.logout();
});

export const refreshToken = createAsyncThunk(
  "auth/refresh", 
  async (newAccessTokenPayload) => {
});

const userHasRole = (state,role) => {

  const foundRole = state.auth?.user?.roles.find(obj => obj.roleId === role);

  if (foundRole !== undefined)
  {
    return true
  }
  else
  {
    return false
  }
}


const initialState = user
  ? { isLoggedIn: true, user , user_roles , user_sessions}
  : { isLoggedIn: false, user: null, user_roles ,user_sessions};

const authSlice = createSlice({
  name: "auth",
  initialState,
  extraReducers: {
    [register.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
    },
    [register.rejected]: (state, action) => {
      state.isLoggedIn = false;
    },

    [login.fulfilled]: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload.user;
    },
    [login.rejected]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
    },

    [updateUserPassword.fulfilled]: (state, action) => {

      state.isLoggedIn = true;
      state.user.user = action.payload.user;
    },
    [updateUserPassword.rejected]: (state, action) => {

    },

    [logout.fulfilled]: (state, action) => {
      state.isLoggedIn = false;
      state.user = null;
    },

    [refreshToken.fulfilled]: (state,action) => {
      state.user.accessToken = action.meta.arg.accessToken;
      state.user.accessTokenExpiresAt = action.meta.arg.accessTokenExpiresAt;
    },



    [getUserRoles.pending]: (state, action) => {
      state.user_roles.loading = true;
    },
    [getUserRoles.fulfilled]: (state, action) => {
      state.user_roles.data = action.payload.data; 
      state.user_roles.loading = false;
    },
    [getUserRoles.rejected]: (state, action) => {
      state.user_roles.data = list
      state.user_roles.loading = false;
    },

    [getSessions.pending]: (state, action) => {
      state.user_sessions.loading = true;
    },
    [getSessions.fulfilled]: (state, action) => {

      state.user_sessions.data = action.payload.sessions; 
      state.user_sessions.loading = false;
    },
    [getSessions.rejected]: (state, action) => {
      state.user_sessions.data = list
      state.user_sessions.loading = false;
    },
    [updateSession.fulfilled]: (state, action) => {
      //debugger;

      let sessions = state.user_sessions.data.list;
      const session = sessions.find((session) => session.id === action.payload.data.id)

      session.isBlocked = action.payload.data.isBlocked;
    },
    

  },
});


const { reducer } = authSlice;
export default reducer;
export {userHasRole};